import L from 'leaflet';
import {
    calculateArea,
    calculateCenterOfPolygon,
    calculatePerimeter,
    filterPolygonPointsByDistance,
} from '../../../../../../core/utils/map.utils';
import { toast } from 'react-toastify';
import { sendDataToParent } from '../../../../base/functions/sendDataToParent';
import { setIsShowPolygonBreakpoints } from '../../../../../../app/redux/slices/isShowPolygonBreakpointsSlice';
import { setMultiPolygonEditedCoords } from '../../../../../../app/redux/slices/multiPolygonEditedCoordsSlice';

export const polygonOnEditedAction = (e, dispatch, map, multiPolygonEditedId) => {
    const {
        layers: { _layers },
    } = e;

    console.log('edited check: ', _layers);
    const editedLayers = Object.values(_layers);
    const layer = editedLayers[0];
    if (editedLayers.length === 1 && layer && layer._latlngs[0].length >= 3) {
        /*filter out unnecessary points based on distance*/
        const filteredPolygonCoords = filterPolygonPointsByDistance(layer._latlngs[0]);

        if (filteredPolygonCoords && filteredPolygonCoords.length >= 3) {
            const leafletConvertedLatLngs = filteredPolygonCoords.map((coord) => L.latLng(coord.lat, coord.lng));

            /*redraw polygon on map with the filtered coords*/
            layer._latlngs[0] = leafletConvertedLatLngs;
            layer.redraw();
            layer.addTo(map);

            const editedPolygonArea = calculateArea(filteredPolygonCoords);
            const editedPolygonCenter = calculateCenterOfPolygon(filteredPolygonCoords);
            const editedPolygonPerimeter = calculatePerimeter(filteredPolygonCoords);

            sendDataToParent({
                type: 'polygon-edited',
                polygonId: layer._leaflet_id,
                editedPolygonCoords: filteredPolygonCoords,
                editedPolygonArea,
                editedPolygonCenter,
                editedPolygonPerimeter,
            });
            toast.success('با موفقیت انجام شد', { toastId: 'success' });
            // dispatch(setIsShowPolygonBreakpoints(false));
            multiPolygonEditedId && dispatch(setMultiPolygonEditedCoords(filteredPolygonCoords));
        }
    } else if (editedLayers.length > 1) {
        const editedPolygons = [];
        // console.log('edited polygons new coords: ', editedPolygons);

        editedLayers.map((layer) => {
            const filteredPolygonCoords = filterPolygonPointsByDistance(layer._latlngs[0]);
            if (filteredPolygonCoords && filteredPolygonCoords.length >= 3) {
                const leafletConvertedLatLngs = filteredPolygonCoords.map((coord) => L.latLng(coord.lat, coord.lng));

                /*redraw polygon on map with the filtered coords*/
                layer._latlngs[0] = leafletConvertedLatLngs;
                layer.redraw();
                layer.addTo(map);

                const editedPolygonArea = calculateArea(filteredPolygonCoords);
                const editedPolygonCenter = calculateCenterOfPolygon(filteredPolygonCoords);
                const editedPolygonPerimeter = calculatePerimeter(filteredPolygonCoords);
                
                editedPolygons.push({
                    id: layer._leaflet_id,
                    coordinates: filteredPolygonCoords,
                    center: editedPolygonCenter,
                    area: editedPolygonArea,
                    perimeter: editedPolygonPerimeter,
                });
            }
        });

        sendDataToParent({
            type: 'multiple-polygons-edited',
            editedPolygons,
        });
    }
};
//     const { _leaflet_id } = layer;
// Object.values(_layers).map(({ _leaflet_id, editing }) => {
//     setMapLayersData((layers) =>
//         layers.map((layer) =>
//             layer.id === _leaflet_id ? { ...layer, latlngs: { ...editing.latlngs[0] } } : layer,
//         ),
//     );
// });
